import { render } from "./Delivery.vue?vue&type=template&id=3e7f67ab&scoped=true"
import script from "./Delivery.vue?vue&type=script&lang=js"
export * from "./Delivery.vue?vue&type=script&lang=js"

import "./Delivery.vue?vue&type=style&index=0&id=3e7f67ab&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e7f67ab"]])

export default __exports__